import _slicedToArray from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    padding: 4px 8px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    display: inline-block;\n    text-decoration: none;\n    height: auto;\n\n    &,\n    &:hover,\n    &:focus,\n    &:active {\n        text-decoration: none;\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import copyToClipboard from 'copy-to-clipboard';
import { Row } from '../Row';
import { Button } from '../Button';
import { Balloon } from '../Balloon';
import { Typography } from '../Typography';
import { CopyIcon, CheckIcon } from '../icons';
var TICK_ICON_TIME = 2000;
var BALLOON_TIME = 1500;
var StyledCopyToClipboard = styled(Button)(_templateObject());
var InnerContent = styled(Typography)(_templateObject2());
var StyledCopyItem = styled(Row.Item)(_templateObject3(), function (_ref) {
  var maxTextWidth = _ref.maxTextWidth;
  return "max-width: ".concat(maxTextWidth, "px;");
});
var StyledRowItem = styled(Row.Item)(_templateObject4());
export function CopyToClipboard(_a) {
  var copyData = _a.copyData,
      _a$disabled = _a.disabled,
      disabled = _a$disabled === void 0 ? false : _a$disabled,
      _a$tooltipTitle = _a.tooltipTitle,
      tooltipTitle = _a$tooltipTitle === void 0 ? 'Copied' : _a$tooltipTitle,
      maxTextWidth = _a.maxTextWidth,
      _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      onClick = _a.onClick,
      props = __rest(_a, ["copyData", "disabled", "tooltipTitle", "maxTextWidth", "children", "onClick"]);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isCopied = _useState2[0],
      setIsCopied = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isOpened = _useState4[0],
      setIsOpened = _useState4[1];

  var tickTimerId = null;
  var tipTimerId = null;
  var handleClickCopy = useCallback(function (event) {
    copyToClipboard(copyData);
    setIsCopied(true);
    tickTimerId && clearTimeout(tickTimerId);
    tickTimerId = setTimeout(function () {
      return setIsCopied(false);
    }, TICK_ICON_TIME);
    setIsOpened(true);
    tipTimerId && clearTimeout(tipTimerId);
    tipTimerId = setTimeout(function () {
      return setIsOpened(false);
    }, BALLOON_TIME);

    if (typeof onClick === 'function') {
      onClick(Object.assign(Object.assign({}, event), {
        value: copyData
      }));
    }
  }, [copyData, onClick]);
  var innerContent = children || copyData;
  return React.createElement(Balloon, {
    content: React.createElement(InnerContent, {
      variant: 'body2'
    }, tooltipTitle),
    opened: isOpened,
    level: 'tooltip',
    placement: 'top-end'
  }, function (_ref2) {
    var ref = _ref2.ref;
    return React.createElement(StyledCopyToClipboard, Object.assign({
      ref: ref,
      variant: 'text',
      onClick: handleClickCopy,
      disabled: disabled
    }, typeof innerContent === 'string' ? {
      title: innerContent
    } : {}, props), React.createElement(Row.Container, {
      gap: 8,
      alignItems: 'center'
    }, React.createElement(StyledCopyItem, {
      maxTextWidth: maxTextWidth
    }, React.createElement(Typography, {
      variant: 'action1',
      ellipsis: true
    }, innerContent)), React.createElement(StyledRowItem, null, isCopied ? React.createElement(CheckIcon, {
      width: 16,
      height: 16
    }) : React.createElement(CopyIcon, {
      width: 14,
      height: 14
    }))));
  });
}